<template>
    <div class="card-text">
        <h2 class="title">
            {{ content.title || card.title }}
        </h2>

        <!-- TODO is this needed? -->
        <div
            v-if="content.description"
            class="description"
        >
            {{ content.description }}
        </div>

        <ThCheckbox
            v-if="isMultiple"
            v-model="checkboxModel"
        />

        <RadioOptionInput
            v-else
            id="card-text"
            v-model="checkboxModel"
            :option="{
                value: true,
                label: '',
                id: content.description || '',
            }"
        />

        <div
            class="screen"
            @click.prevent.stop="$emit('toggle', !isSelected)"
        ></div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import type { QuestionnaireQuestionChoiceOptionContentTextFragment } from '@/graphql/api'
import { getOptionContent } from '../composables/evaluateConditions.ts'
import type { QuestionnaireStore } from '@/components/cms/component/questionnaire/useQuestionnaireStore'

import ThCheckbox from '@/components/ui/inputs/ThCheckbox.vue'
import RadioOptionInput from '@/components/ui/inputs/RadioOptionInput.vue'

const props = defineProps<{
    card: QuestionnaireQuestionChoiceOptionContentTextFragment
    questionnaireStore: QuestionnaireStore
    isSelected: boolean | undefined
    isMultiple: boolean | undefined
}>()

const emit = defineEmits<{
    'toggle': [select: boolean]
}>()

const checkboxModel = computed({
    get: () => props.isSelected,
    set: (isSelected: boolean) => emit('toggle', isSelected),
})

const route = useRoute()

const content = computed(() =>
    getOptionContent(
        props.card,
        props.questionnaireStore,
        route.params['id'] as string
    )
)
</script>
<style lang="scss" scoped>
.card-text {
    position: relative;
    width: 100%;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    &:not(:last-of-type) {
        border-bottom: 1px solid var(--grey-200);
    }

    .screen {
        position: absolute;
        inset: 0;
    }

    .title {
        margin-right: 16px;
        font-family: $sectra-font-stack;
        font-style: normal;
        font-weight: 350;
        font-size: 1rem;
    }

    .description {
        margin-right: 16px;
        font-family: $sectra-font-stack;
        font-style: normal;
        font-weight: 350;
        font-size: 0.875rem;
    }
}
</style>
